import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";

const PAGE_SIZE = 10;

export const useChangeStoreHeader = () => {
  const { authData, storeId, storeName } = useSelector(
    (state) => state.loginSlice
  );
  const dispatch = useDispatch();

  const location = useLocation();
  const { pathname } = location;
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [initiallyHadData, setInitiallyHadData] = useState(false);

  const fetchStores = async (searchQuery = "", page = 1, append = false) => {
    try {
      setLoading(true);
      const response = await apiHandler({
        url: `${endpoint.API_BASE_URL}${endpoint.GET_STORES}?iPageSize=${PAGE_SIZE}&iPageNumber=${page}&sSearchByName=${searchQuery}`,
        method: "GET",
        authToken: authData,
        dispatch,
      });

      if (response?.data?.status === "success") {
        const storeList = response?.data?.data?.storeData;
        const totalRecords = response?.data?.data?.totalRecords;

        if (totalRecords > 0 && !initiallyHadData) {
          setInitiallyHadData(true);
        }
        setStores((prev) => (append ? [...prev, ...storeList] : storeList));
      }
    } catch (err) {
      console.error("Error fetching stores:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStores();
  }, []);

  return {
    storeId,
    storeName,
    stores,
    loading,
    fetchStores,
    initiallyHadData,
  };
};

export default useChangeStoreHeader;
